import type { IGlobalTab } from '@carboncopyco/types/desktop';
import { useCallback, useMemo, useState } from 'react';
import { UserEventsEnum } from '../../../../shared/enums/UserEventsEnum';
import useElectronListener from '../../../hooks/useElectronListener';
import { useTabManager } from '../../../services/TabManager';

export interface IEditorPageInfo {
  title?: string;
  url?: string;
}

export const useEditorPageInfo = (
  tab: IGlobalTab
): IEditorPageInfo | undefined => {
  const { updateTabProperty } = useTabManager();
  const [url, setURL] = useState<string>();
  const [title, setTitle] = useState<string>();
  const { getDemoPageUrl } = window?.dsDesktop.editor;
  const activeTab = useMemo(
    () => tab.innerTabs.find(({ id }) => id === tab.activeInnerTabId),
    [tab.activeInnerTabId]
  );

  const handleNavigationChanged = useCallback(
    async (message: { innerTabId: number }) => {
      if (!activeTab) return;
      const { id } = activeTab;
      if (id === message.innerTabId) {
        const demoPageUrl = await getDemoPageUrl(id);
        setURL(demoPageUrl);
        updateTabProperty(tab, 'url', demoPageUrl);
      }
    },
    [activeTab]
  );

  const handleTitleChanged = useCallback(
    (message: { innerTabId: number; title: string }) => {
      if (!activeTab) return;
      const { id } = activeTab;
      if (id === message.innerTabId) {
        setTitle(message.title);
      }
    },
    [activeTab]
  );

  useElectronListener<{ innerTabId: number }>(
    UserEventsEnum.ON_BROWSER_NAVIGATION_CHANGED,
    handleNavigationChanged
  );

  useElectronListener<{
    innerTabId: number;
    title: string;
  }>(UserEventsEnum.ON_BROWSER_TITLE_CHANGED, handleTitleChanged);

  return !url && !title ? undefined : { url, title };
};
